import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const SecondMorningSnackIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 44 44" {...props}>
      <path
        d="M21.6667 43.3333C33.6328 43.3333 43.3333 33.6328 43.3333 21.6667C43.3333 9.7005 33.6328 0 21.6667 0C9.7005 0 0 9.7005 0 21.6667C0 33.6328 9.7005 43.3333 21.6667 43.3333Z"
        fill="#FFCBC1"
      />
      <path
        d="M32.893 14.3939C32.7334 13.5328 31.9629 12.9179 31.0879 12.9535C29.3444 13.0243 26.1859 13.5524 22.5758 16.0231C23.4876 18.3586 24.1463 21.3644 24.1463 25.1772C24.1463 29.7886 21.9653 32.8582 19.002 33.7389C21.7715 34.5676 25.1215 33.4431 27.8181 30.0636C33.5521 22.8775 33.3701 16.9684 32.893 14.3939Z"
        fill="#994E37"
      />
      <path
        d="M16.0291 9.76366C16.6909 9.19011 17.6767 9.19011 18.3385 9.76366C20.3172 11.4785 24.145 15.9839 24.145 25.1772C24.145 30.69 21.0283 34.0002 17.1838 34.0002C13.3393 34.0002 10.2227 30.69 10.2227 25.1772C10.2227 15.9839 14.0505 11.4785 16.0291 9.76366Z"
        fill="#CC624E"
      />
      <path
        d="M24.1463 25.1768C24.1463 29.7882 21.9653 32.8578 19.002 33.7385C19.4917 33.8851 19.9996 33.9702 20.5188 33.9929C23.218 32.8631 25.1398 29.8454 25.1398 25.4692C25.1398 21.2568 24.3534 18.008 23.3036 15.5468C23.0632 15.6969 22.8206 15.8552 22.5758 16.0227C23.4876 18.3582 24.1463 21.364 24.1463 25.1768Z"
        fill="#8C4534"
      />
      <path
        d="M18.3406 9.76348C17.8887 9.3719 17.2859 9.24789 16.7383 9.39098C16.9928 9.45746 17.2354 9.58152 17.4454 9.76348C19.4241 11.4783 23.2519 15.9837 23.2519 25.1771C23.2519 30.4742 20.3742 33.737 16.7383 33.9843C16.8864 33.9943 17.0355 34 17.1859 34C21.0304 34 24.147 30.6899 24.147 25.1771C24.147 15.9837 20.3192 11.4783 18.3406 9.76348Z"
        fill="#BC574A"
      />
      <path
        d="M18.9268 10.3098C18.7177 10.1032 18.5198 9.92144 18.3376 9.76361C18.1364 9.58916 17.9051 9.46814 17.6621 9.39978C18.1724 10.3381 18.8374 11.8642 19.4031 14.1611C20.1675 17.2644 20.555 20.9706 20.555 25.1768C20.555 30.2819 19.2739 33.2712 17.8386 33.9669C18.3616 33.9144 18.8677 33.7987 19.3507 33.6231C19.6556 33.2259 19.9327 32.7388 20.1746 32.1668C20.9115 30.4247 21.301 28.0076 21.301 25.1769C21.301 20.9106 20.9062 17.1444 20.1274 13.9828C19.7488 12.4454 19.3241 11.2374 18.9268 10.3098Z"
        fill="#994E37"
      />
      <path
        d="M13.8124 25.1778C13.8124 20.9717 14.1999 17.2655 14.9642 14.1621C15.53 11.8653 16.1951 10.3391 16.7053 9.40076C16.4623 9.46907 16.231 9.59014 16.0297 9.76459C15.8476 9.92247 15.6497 10.1041 15.4406 10.3108C15.0433 11.2383 14.6186 12.4463 14.24 13.9837C13.4613 17.1453 13.0664 20.9116 13.0664 25.1778C13.0664 28.0085 13.4559 30.4256 14.1928 32.1678C14.4347 32.7398 14.7118 33.2268 15.0167 33.624C15.4996 33.7997 16.0057 33.9153 16.5287 33.9679C15.0935 33.2723 13.8124 30.2829 13.8124 25.1778Z"
        fill="#994E37"
      />
      <path
        d="M17.5565 33.9895V9.37341C17.3109 9.32052 17.0562 9.32052 16.8105 9.37341V33.9895C16.9341 33.9965 17.0584 34.0002 17.1835 34.0002C17.3087 34.0002 17.433 33.9965 17.5565 33.9895Z"
        fill="#994E37"
      />
      <path
        d="M23.5561 19.311C26.9339 16.0245 30.3288 13.7712 31.8606 13.0977C31.6234 12.9946 31.3607 12.9424 31.0879 12.9535C30.8878 12.9616 30.669 12.9758 30.4331 12.9983C28.679 14.0071 26.0477 15.8982 23.3574 18.4662C23.4276 18.7407 23.4939 19.0224 23.5561 19.311Z"
        fill="#70362B"
      />
      <path
        d="M33.0158 15.2079C32.9808 14.9081 32.9385 14.6361 32.8936 14.3937C32.8445 14.1288 32.7374 13.8873 32.5874 13.6808C32.3723 15.0358 31.7708 16.8752 30.9443 18.6881C29.5673 21.708 27.5739 24.7795 25.0193 27.8175C24.4304 28.5178 23.8623 29.1022 23.3344 29.5992C23.0167 30.3621 22.6149 31.0351 22.1445 31.6107C23.0506 30.8754 24.2651 29.8734 25.5903 28.2976C28.1883 25.2078 30.2181 22.0789 31.623 18.9976C32.3325 17.4413 32.7593 16.1657 33.0158 15.2079Z"
        fill="#70362B"
      />
      <path
        d="M24.0703 23.0005C24.096 23.3665 24.1158 23.7405 24.1284 24.1238L32.5246 13.6012C32.3655 13.4067 32.1665 13.2479 31.9415 13.136L24.0703 23.0005Z"
        fill="#70362B"
      />
      <path
        d="M24.3262 18.5795C24.0701 18.8172 23.8129 19.0614 23.5563 19.311C23.4944 19.0283 23.4291 18.7465 23.3574 18.4661C23.6061 18.2284 23.8548 17.9967 24.1019 17.7709C24.1805 18.0334 24.2551 18.303 24.3262 18.5795Z"
        fill="#5E2B25"
      />
      <path
        d="M24.9165 27.9384C24.8111 28.4919 24.6699 29.0141 24.4963 29.5039C23.6026 30.4184 22.7945 31.0833 22.1445 31.6105C22.3955 31.3023 22.6217 30.9743 22.8222 30.6313C22.9188 30.466 23.01 30.2975 23.0944 30.1258C23.1795 29.9527 23.2533 29.7744 23.3341 29.5994C23.8309 29.1314 24.3641 28.5854 24.9165 27.9384Z"
        fill="#5E2B25"
      />
      <path
        d="M25.0425 22.9778V22.9782L24.1289 24.1231L24.1285 24.1236C24.122 23.9321 24.1141 23.7426 24.1046 23.5556C24.0947 23.3686 24.0832 23.1836 24.0703 23.0006L24.0713 22.9996L24.9387 21.9125C24.9788 22.2592 25.0142 22.6142 25.0425 22.9778Z"
        fill="#5E2B25"
      />
    </SvgIcon>
  );
};

export default SecondMorningSnackIcon;
